import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type UserRole = 'admin' | 'client' | 'service';

interface User {
  id: string;
  username: string;
  email: string;
  role: UserRole;
  organization_id?: string | null;
  avatar?: string;
}

interface AuthState {
  token: string | null;
  apiKey: string | null;
  user: User | null;
  isAuthenticated: boolean;
  
  // Actions
  setAuth: (token: string, user: User) => void;
  setApiKey: (key: string) => void;
  updateUser: (updates: Partial<User>) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      apiKey: null,
      user: null,
      isAuthenticated: false,

      setAuth: (token, user) => {
        // Sync token to localStorage for API client
        localStorage.setItem('auth-token', token);
        set({
          token,
          user,
          isAuthenticated: true,
        });
      },

      setApiKey: (apiKey) => set({ apiKey }),

      updateUser: (updates) =>
        set((state) => ({
          user: state.user ? { ...state.user, ...updates } : null,
        })),

      logout: () => {
        // Clear token from localStorage
        localStorage.removeItem('auth-token');
        set({
          token: null,
          apiKey: null,
          user: null,
          isAuthenticated: false,
        });
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        token: state.token,
        apiKey: state.apiKey,
        user: state.user,
        isAuthenticated: state.isAuthenticated,
      }),
    }
  )
);

